import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MaterialCheckbox } from '@everfi/reactifi';
import LocaleHelper from 'lib/utility/locale_helper';
import { FloatingLabelFormField, SelectControl } from 'reactifi';
import { sanitizeUrl } from '@braintree/sanitize-url';

export default class ExportTranslations extends Component {
  static propTypes = {
    importPath: PropTypes.string.isRequired,
    exportPath: PropTypes.string.isRequired,
    global: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedLocale: 'en',
      onlyMissing: false
    };
  }

  onLocaleChange = (e) => {
    if(!e.id) return;

    this.setState({ selectedLocale: e.id });
  }

  updateOnlyMissing = (checked) => {
    this.setState({ onlyMissing: checked });
  }

  get exportPath() {
    let missing = this.state.onlyMissing;
    let locale = this.state.selectedLocale;
    let global_translation = this.props.global;
    return sanitizeUrl(`${this.props.exportPath}?selected_locale=${locale}&only_missing=${missing}&global=${global_translation}`);
  }

  get languageSelectData() {
    const languages = LocaleHelper.supportedLanguages
      .map(this.mapLocale)
      .sort(this.sortLocale);

    return languages;
  }

  mapLocale = (locale) => {
    const key = Object.keys(locale)[0];
    return ({
      id: key,
      text: locale[key]
    });
  };

  sortLocale = (object_a, object_b) => {
    return (object_a.text > object_b.text ? 1 : -1);
  };

  render() {
    let import_verbiage = this.props.global
      ? 'Add translated global records. This process will affect ALL accounts using the affected records.'
      : 'Add translated records to this account';
    return (
      <div className="container m-0">
        <div className="row">
          <div className="col-md-1">
            <a
              id="import_translations_button"
              href={this.props.importPath}
              className="btn btn-primary"
              size="xs"
              data-no-turbolink="true"
            >
              Import
            </a>
          </div>

          <div className="col-md-3">
            <p>{import_verbiage}</p>
          </div>
        </div>

        <hr />

        <div className="row p-t-5 m-b-5">
          <div className="col-md-1">
            <a
              id="export_translations_button"
              href={this.exportPath}
              className="btn btn-primary"
              size="xs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Export
            </a>
          </div>

          <div className="col-md-5">
            <p>
              Generate files containing the translatable attributes of each
              record
            </p>
          </div>
        </div>

        <div className="row p-l-5">
          <div className="col-md-2">
            <FloatingLabelFormField caption="Select Language" dataValue={this.state.selectedLocale} name="selected_locale">
              <SelectControl
                options={this.languageSelectData}
                valueKey="id"
                labelKey="text"
                onChange={this.onLocaleChange}
                defaultValue={this.state.selectedLocale}
              />
            </FloatingLabelFormField>
          </div>

          <div className="col-md-4">
            <MaterialCheckbox
              onChange={this.updateOnlyMissing}
              label="Only missing translations"
              id="only_missing"
              name="only_missing"
            />
          </div>
        </div>
      </div>
    );
  }
}
